export class SearchConsumerModel {
  Page: number;
  PageSize: number;
  SearchTerm?: string; 
  OrderColumn?: string;
  OrderDirection?: string;
  SiteId: number;
  ShowAll?: boolean;
  ShowHasIssues?: boolean;
  ShowVulnerable?: boolean;
  ShowActive?: boolean;
  ShowPayg?: boolean;
  ShowBilling?: boolean;
}
